import { Injectable } from '@angular/core';
import { PublisherTagsAndPromotionalTypesSelectors } from 'app/modules/communication-centre/advertiser/store/publisher-tags-and-promotional-types/publisher-tags-and-promotional-types.selectors';
import { SelectableDataCategoryGroup } from 'app/modules/main/components/data-selector/data-selector.models';
import { SelectableDataCategory } from 'app/modules/main/components/data-selector/data-selector.models';
import { SelectableData } from 'app/modules/main/components/data-selector/data-selector.models';
import { SelectableDataCategoryFilter } from 'app/modules/main/components/data-selector/data-selector.models';
import { PromotionalTypeGroup } from 'app/modules/main/models/publisher-tags-and-promotional-types';
import { PromotionalType } from 'app/modules/main/models/publisher-tags-and-promotional-types';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PromotionalTypeGroupFilter implements SelectableDataCategoryFilter<PromotionalType, PromotionalTypeGroup> {

  private readonly displayGroupLabel = $localize`:@@communication-centre.advertiser.promotional-type-selector.filter.group.display:Display`;
  private readonly unsegmentedGroupLabel = $localize`:@@communication-centre.advertiser.promotional-type-selector.filter.group.unsegmented:Unsegmented`;
  private readonly searchGroupLabel = $localize`:@@communication-centre.advertiser.promotional-type-selector.filter.group.search:Search`;
  private readonly contentGroupLabel = $localize`:@@communication-centre.advertiser.promotional-type-selector.filter.group.content:Content`;
  private readonly emailGroupLabel = $localize`:@@communication-centre.advertiser.promotional-type-selector.filter.group.email:Email`;

  private categorySelected = false;

  private readonly selectedPromotionalTypeIds = new Set<number>();

  private readonly promotionalTypes: Observable<PromotionalTypeGroup[]> =
    this.publisherTagsAndPromotionalTypesSelectors.getPublisherTagsAndPromotionalTypes()
      .pipe(map(publisherTagsAndPromotionalTypes => publisherTagsAndPromotionalTypes.promotionalTypes));

  readonly groups: Observable<SelectableDataCategoryGroup<PromotionalTypeGroup>[]> =
    this.promotionalTypes
      .pipe(map((promotionalTypes) => this.toGroups(promotionalTypes)));

  constructor(
    private readonly publisherTagsAndPromotionalTypesSelectors: PublisherTagsAndPromotionalTypesSelectors,
  ) {
  }

  clear(): Observable<void> {

    this.categorySelected = false;
    this.selectedPromotionalTypeIds.clear();

    return of(null);
  }

  select(
    selectedCategory: SelectableDataCategory<PromotionalTypeGroup>
  ): Observable<void> {

    this.categorySelected = true;
    this.selectedPromotionalTypeIds.clear();

    selectedCategory.value.types
      .map(promotionalType => promotionalType.id)
      .forEach(promotionalTypeId => this.selectedPromotionalTypeIds.add(promotionalTypeId));

    return of(null);
  }

  isMatch(
    selectablePromotionalType: SelectableData<PromotionalType>
  ): boolean {

    if (!this.categorySelected) {
      return true;
    }

    return this.selectedPromotionalTypeIds.has(selectablePromotionalType.data.id);
  }

  private toGroups(
    promotionalTypeGroups: PromotionalTypeGroup[]
  ): SelectableDataCategoryGroup<PromotionalTypeGroup>[] {

    return [{
      categories:
        promotionalTypeGroups
          .map(promotionalTypeGroup => {
            return {
              id: promotionalTypeGroup.name,
              label: this.localizeGroupLabel(promotionalTypeGroup.name),
              value: promotionalTypeGroup
            };
          })
    }];
  }

  private localizeGroupLabel(
    label: string
  ): string {

    switch (label) {

      case 'Display':
        return this.displayGroupLabel;

      case 'Unsegmented':
        return this.unsegmentedGroupLabel;

      case 'Search':
        return this.searchGroupLabel;

      case 'Content':
        return this.contentGroupLabel;

      case 'Email':
        return this.emailGroupLabel;

      default:
        return label;
    }
  }

}
